<template>
  <div class="banner">
    <div class="block">
      <el-carousel height="600px">
        <el-carousel-item v-for="item in img" :key="item">
          <img :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: [
        "http://zh-app-store.oss-cn-shenzhen.aliyuncs.com/appHtml/official-website/baseImg/public2/banner1.jpg",
        "http://zh-app-store.oss-cn-shenzhen.aliyuncs.com/appHtml/official-website/baseImg/public2/banner2.jpg"
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.banner {
  padding-top: 80px;
  width: 100%;

  img {
    width: 100%;
  }
}

/deep/.el-carousel__button {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
</style>
